export type UserType = (typeof UserTypes)[keyof typeof UserTypes];

export const UserTypes = {
  STAFF: "staff",
  CITIZEN: "citizen",
} as const;
